export const iconFontAwesomeMovingHouseChimney = (
	<i className="fa-solid fa-house-chimney"></i>
);
